export enum Colors {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}
